module.exports = __webpack_public_path__ + "static/media/telos2.de732e7f.jpg";